import React, {Suspense, useContext, useEffect, useState} from 'react';
import { useSelector } from 'react-redux';

import Checkers from '../../../helpers/class/Checkers';
import * as appContext from '../../AppContext';
import GoogleMapSection from '../../GoogleMapSection';

import LeftSide from './content/columned/LeftSide';
import RightSide from './content/columned/RightSide';
import {fetchBuilderSettingByKey} from "../../../helpers/MethodHelper";
import {RelatedProperties} from "./content/columned/left/RelatedProperties";

export default function Content ( props ) {
    const isPublicDomain = useSelector(state => state['appSettings']['isPublicDomain']);
    const isBookingsActive = useSelector(state => (state['appSettings']['isBookingsActive']==1 && fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_bookings_activate')==1) ? 1 : 0);
    const isHotel = useSelector(state => state['appSettings']['isHotel'])
    const isChain = useSelector(state => state['appSettings']['isChain'])
    const isSingleVilla = !props.app_data?.is_manager

    const latitude = props.location.latitude;
    const longitude = props.location.longitude;
    const googleMapShow = props.app.viewMap && Checkers.valueToBoolean(props.app.builder.builder_singleproperty_show_map)
    const googleMapApiKey = props.googleMapApiKey;
    const legalLicense =
        Checkers.objChildExists(props.details, 'property_legal_license') &&
        Checkers.isValidString(props.details.property_legal_license) ?
            props.details.property_legal_license : null;


    const [showSidebar, setShowSidebar] = useState(true);

    const hidePin = Checkers.valueToBoolean(props.app.builder.builder_propertylist_map_hide_pin)

    const showSidebarHandler = () => {
        if (isPublicDomain == 1 || isBookingsActive == 0) {
            setShowSidebar(false)
        }
    }

    useEffect( () => {
        showSidebarHandler()
    }, [isBookingsActive, isPublicDomain])

    const bookingBoxPosition = props.app.builder.builder_singleproperty_booking_box_position

    // useEffect( () => {
    //     console.log("bookingBoxIsLeft", bookingBoxIsLeft)
    // })

    const terms = Checkers.isValidString(props.terms) ? props.terms : ( Checkers.isValidArrayOfString(props.terms) ? props.terms : props.details.desc_rules)

    const moveRelatedPropertiesBelowMap = useSelector(
        state => Checkers.valueToBoolean(fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_singleproperty_related_properties_move_below_map'))
    );

    return (
        <>
            <section key={0} className="bg-master-lightest">
                <div className="container">
                    <div className="row">
                        {
                            !props.hideSidebar && bookingBoxPosition == 'LEFT' && showSidebar ?
                                <RightSide legalLicense={legalLicense} phone={props.phone} builder={props.builder}
                                           hasOpenCalendar={props.hasOpenCalendar}/>
                                :
                                <></>
                        }
                        <LeftSide
                            hideDescription={props.hideDescription}
                            hideThemes={props.hideThemes}
                            hideFeaturedImages={props.hideFeaturedImages}
                            hideExperiences={props.hideExperiences}
                            hideTerms={props.hideTerms}
                            profileBeforeSpaces={props.profileBeforeSpaces}
                            galleryAfterProfile={props.galleryAfterProfile}
                            distinctsBeforeAttributes={props.distinctsBeforeAttributes}
                            overviewBeforeSpaces={props.overviewBeforeSpaces}
                            hideMedia={props.hideMedia}
                            mediaAfterPolicies={props.mediaAfterPolicies}
                            fourColumnsFeatures={props.fourColumnsFeatures}
                            hideSidebar={props.hideSidebar}
                            app={props.app}
                            app_data={props.app_data}
                            details={props.details}
                            terms={terms}
                            location={props.location}
                            images={props.images}
                            images_count={props.images_count}
                            property_id={props.details.property_id}
                            all_images={props.all_images}
                            spaces={props.spaces}
                            features={props.features}
                            services={props.services}
                            themes={props.themes}
                            page_title={props.page_title}
                            builder={props.builder}
                            highlights={props.highlights}
                            map_pois={props.map_pois}
                            isHotel={props.isHotel}
                            isSingleVilla={isSingleVilla}
                        />
                        {
                            !props.hideSidebar && !isHotel && !isChain && bookingBoxPosition != 'LEFT' && showSidebar ?
                                <RightSide legalLicense={legalLicense} phone={props.phone} builder={props.builder}
                                           hasOpenCalendar={props.hasOpenCalendar}/>
                                :
                                <></>
                        }
                    </div>
                </div>
            </section>
            {
                props.hideMap ? <></> :
                <GoogleMapSection
                    app={props.app}
                    googleMapApiKey={googleMapApiKey}
                    googleMapShow={googleMapShow}
                    property_lat={latitude}
                    property_lng={longitude}
                    map_pois={props.map_pois}
                    hidePin={hidePin}
                    descAreaDistances={Checkers.isValidObjString(props.details, 'desc_area_distances') && props.details.desc_area_distances}
                    propertyTitle={props.details?.property_title}
                    propertyImages={Checkers.isValidArray(props.images) ? props.images.map((image) => image.image_thumb || image.image) : []}
                    propertyAddress={props.location}
                />
            }
            {
                moveRelatedPropertiesBelowMap && !isSingleVilla && !isHotel ?
                    <>
                        <RelatedProperties key={'related-properties'} propertyId={props.property_id} app_data={props.app_data} app={props.app} builder={props.builder} slidesPerViewDesktop={3.5} isChain isHotel/>
                    </>
                    :
                    <></>
            }
        </>
    )
}
